import { useTranslation } from "react-i18next";
import MainCard from "../MainCard";
import RemoteParticipantView from "../RemoteParticipantView";
import useIsMobile from "../../utils/useIsMobile";
import React, { useEffect, useRef, useState } from "react";
import { useAppContext } from "../../AppContextDef";
import CharacterView from "../CharacterView";
import ConfirmDialog from "../ConfirmDialog";
import JourneyAlertModal from "../JourneyAlertModal";
import imageSrc from "../../repeat_audio_icon.png";
import { APP_FONT_STACK } from "../../utils/common";
import { useParticipant, usePubSub } from "@videosdk.live/react-sdk";
import RecorderStatsPanel from "../RecorderStatsPanel";

const VideoConsentSection = ({ formattedTime, characterJoined }) => {
  const {
    isTimerRunningData: isTimerRunning,
    journeyConfigData,
    timerData: timer,
    currentPage,
    agreedData,
    selectedLang,
    openVideoErr,
    openVideoFailErr,
    setOpenVideoErr,
    setOpenVideoFailErr,
    isJourneyEnded,
    openDeviceChange,
    setOpenDeviceChange,
    openVideoFreeze,
    setOpenVideoFreeze,
    openTextMatchErr,
    setOpenTextMatchErr,
    accuracy,
  } = useAppContext();
  const { t, i18n } = useTranslation();
  const isMobile = useIsMobile();
  const [messageSent, setMessageSent] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const [isCharacterSpeaking, setIsCharacterSpeaking] = useState(false)
  // const { getVideoStats } = useParticipant("customer")
  // const [isBadNetwork, setIsBadNetwork] = useState(false);
  // const frameRatesRef = useRef([]);

  // const { publish: badNetworkPublish } = usePubSub(`BAD_NETWORK`);



  // const getParticipantStats = async () => {
  //   try {
  //     const stats = await getVideoStats();

  //     const framerate = stats ? stats[0]?.size?.framerate : 0;

  //     frameRatesRef.current = [...frameRatesRef.current, framerate].slice(-5);

  //     const allLow = frameRatesRef.current.every(rate => rate < 5);
  //     const allHigh = frameRatesRef.current.every(rate => rate >= 5);

  //     if (allLow) {
  //       badNetworkPublish({ isBadNetwork: true }, { persist: true });
  //       console.log(`Customer is experiencing network issues. Network event published at ${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}`);
  //       setIsBadNetwork(true)
  //     }
  //     if (allHigh) {
  //       badNetworkPublish({ isBadNetwork: false }, { persist: true });
  //       setIsBadNetwork(false)
  //     }

  //   } catch (err) {
  //     console.error("Failed to get stats:", err);
  //   }
  // };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     getParticipantStats();
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, []);


  useEffect(() => {
    changeLanguage(selectedLang?.lang);
  }, [selectedLang]);

  let videoConsentText = journeyConfigData?.clientScript;

  const isEnabled =
    agreedData &&
    !isCharacterSpeaking &&
    messageSent &&
    !isTimerRunning?.isRunning

  const fontFamilyCSS = APP_FONT_STACK;

  // This page is captured by a headless browser at a fixed viewport, so anything
  // that does not fit is absent from the recording — a scrollbar is not a
  // fallback. Hence: no overflow anywhere, `h-full` (not `h-screen`, which
  // overflowed by exactly the parent's padding), and the stats panel placed
  // BESIDE the video rather than below it, so the tall part of the page costs
  // max(stats, video) instead of stats + video.
  //
  // RemoteParticipantView gets showStats={false} because the panel is mounted
  // here instead. Exactly one RecorderStatsPanel may exist per page — it owns a
  // 1s stats poll against the customer's tracks.
  return (
    <div className="flex min-h-0 flex-col max-h-screen md:h-full w-full overflow-hidden bg-white py-0 px-0 md:py-6 md:px-9 lg:px-8 xl:px-14">
      <MainCard
        formattedTime={formattedTime}
        mainTitle={t("Video Consent")}
        mainClassCss={
          "flex flex-1 flex-col h-full min-h-0 justify-start overflow-hidden md:border md:rounded-xl py-3 px-3 md:py-6 md:px-9 lg:px-8 xl:px-14"
        }
        classNameFirstSection={"flex w-full min-h-0 flex-1 flex-col"}
        // MainCard's title row defaults to `flex-1`, which would make the header
        // grow now that its parent is a flex column. Pin it to its own height.
        classNameTitleContainer={"!flex-none"}
        mainTitleCss={
          "hidden md:flex text-2xl text-black-200 font-extrabold mb-0"
        }
        FirstSection={
          // The title is pinned to the top; everything else is one group,
          // vertically centred in the space beneath it (`justify-center`).
          //
          // Stats sit BESIDE the video rather than beneath it, so this row costs
          // max(stats, video) instead of their sum — that is what keeps every
          // card inside the headless browser's viewport.
          <div
            className={`flex min-h-0 flex-1 flex-col justify-center gap-4 md:mt-2 ${isMobile && "sticky top-40"} px-2 md:px-0`}
          >
            <div className="flex shrink-0 flex-col-reverse gap-4 lg:flex-row items-center">
              <div className="w-full min-h-0 lg:w-2/5">
                <RecorderStatsPanel />
              </div>

              <div className="flex w-full shrink-0 flex-col gap-3 lg:w-3/5">
                <RemoteParticipantView showStats={false} />

                <CharacterView
                  isRecorder={true}
                  characterJoined={characterJoined}
                  currentPage={currentPage}
                  setIsCharacterSpeaking={setIsCharacterSpeaking}
                  isCharacterSpeaking={isCharacterSpeaking}
                  agreed={agreedData}
                  messageSent={messageSent}
                  setMessageSent={setMessageSent}
                  selectedLang={selectedLang}
                  message={`${t(
                    "Please record your video consent by clicking Start and clearly reading the text displayed on the screen. When you're done, click Stop to complete the process."
                  )}`}
                />
              </div>
            </div>

            <div className="shrink-0">
            {isTimerRunning?.isRunning && (
              <div
                style={{ fontFamily: fontFamilyCSS }}
                className="mt-3 text-base md:text-lg font-bold text-left md:text-center"
              >
                {t("timeRemaining", { timer })}
              </div>
            )}

            {isJourneyEnded ? (
              <div className="mt-4">
                <div className=" flex justify-center items-center w-full h-11 ">
                  <div
                    style={{ borderTopColor: "#EA7617" }}
                    className="animate-spin  ease-linear rounded-full border-4  border-gray-100 h-12 w-12"
                  ></div>
                </div>
                <p
                  style={{ fontFamily: fontFamilyCSS }}
                  className="text-center text-base md:text-lg text-black-150 mt-3"
                >
                  {`${t("Please wait while we verify your recording")}...`}
                </p>
              </div>
            ) : (
              videoConsentText && (
                <p
                  style={{ fontFamily: fontFamilyCSS }}
                  className={`text-left md:text-center text-base font-bold ${isTimerRunning?.isRunning ? "mt-3" : "mt-4"
                    }`}
                >
                  {videoConsentText}
                </p>
              )
            )}

            {!isJourneyEnded && (
              <div className="mt-3 flex items-center justify-center">
                {!isTimerRunning?.isRunning ? (
                  <button
                    disabled={!isEnabled}
                    style={{ fontFamily: fontFamilyCSS }}
                    className={`disabled:bg-opacity-15 disabled:cursor-not-allowed bg-orange-150 text-white p-3 rounded-md w-full font-bold md:max-w-max`}
                  >
                    {t("Start")}
                  </button>
                ) : (
                  <button
                    style={{ fontFamily: fontFamilyCSS }}
                    className="bg-gray-100 text-black-150 p-3 rounded-md border border-darkGray-150 ml-3 w-full font-bold md:max-w-max"
                  >
                    {t("Stop")}
                  </button>
                )}
                <button
                  style={{ fontFamily: fontFamilyCSS }}
                  className={`bg-blue-250 text-blue-150 flex items-center justify-center p-3 ml-3 rounded-md font-bold max-w-max`}
                >
                  <img src={imageSrc} alt="icon" className="w-6 h-6" />
                </button>
              </div>
            )}
            </div>
          </div>
        }
      />
      {/* No SecondSection: the action bar moved into FirstSection so it centres
          together with the columns and the consent script. */}
      {openVideoErr && (
        <ConfirmDialog
          open={openVideoErr}
          setOpen={setOpenVideoErr}
          dismissible={false}
          buttonText={`${t("Record again")}`}
          text={` ${t(
            "The spoken text is inaccurate. Please try recording again."
          )}`}
          buttonHandler={() => {
            setOpenVideoErr(false);
          }}
          extraButtonText={`${t("Return to homepage")}`}
          extraButtonHandler={() => {
            setOpenVideoErr(false);
          }}
          selectedLang={selectedLang}
          thirdButtonText={`${t("Submit for Validation")}`}
          thirdButtonHandle={() => {
            setOpenVideoErr(false);
          }}
          thirdButtonCondition={accuracy > 60 ? true : false}


        />
      )}
      {openTextMatchErr && (
        <ConfirmDialog
          open={openTextMatchErr}
          setOpen={setOpenTextMatchErr}
          dismissible={false}
          text={t(
            "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR099]"
          )}
          buttonText={t("Return to homepage")}
          buttonHandler={async () => {
            setOpenTextMatchErr(false);
          }}
        />
      )}
      {openVideoFailErr && (
        <JourneyAlertModal
          variant="recordingFailed"
          open={openVideoFailErr}
          selectedLang={selectedLang}
          onClose={() => setOpenVideoFailErr(false)}
          onPrimary={() => setOpenVideoFailErr(false)}
        />
      )}
      {openDeviceChange && (
        <ConfirmDialog
          open={openDeviceChange}
          setOpen={setOpenDeviceChange}
          dismissible={false}
          buttonText={`${t("Record Again")}`}
          buttonHandler={async () => {
            setOpenDeviceChange(false)
          }}
          text={`${t(
            "Your video consent could not be recorded due to a device change. Please try again."
          )}`}
        />
      )}
      {openVideoFreeze && (
        <ConfirmDialog
          open={openVideoFreeze}
          setOpen={setOpenVideoFreeze}
          dismissible={false}
          selectedLang={selectedLang}
          buttonText={`${t("Record again")}`}
          buttonHandler={async () => {
            setOpenVideoFreeze(false)
          }}
          text={`${t(
            "Your video froze because of an unstable network connection, so your recording was not saved. Please record and speak again."
          )}`}
        />
      )}
      {/* The "network unstable" dialog is rendered globally in RecordingContainer
          so it appears on every recorder page, not just here. */}
    </div>
  );
};

export default VideoConsentSection;
